import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import perform from 'ember-concurrency/helpers/perform';
import t from 'ember-intl/helpers/t';

import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{t 'tool_itunes_import.headline'}}
    </:title>

    <:description>
      {{t 'tool_itunes_import.description'}}
    </:description>

    <:body>
      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{@controller.ituneImportSettings}}
        as |form|
      >
        <div class='o-layout'>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset @titleKey='settings' as |fieldset|>
              <fieldset.field @property='upc' />

              <Button
                @label={{t 'tool_itunes_import.import'}}
                @disabled={{@controller.isDisabled}}
                @icon='download'
                {{on 'click' (perform @controller.importProduct)}}
              />
            </form.fieldset>
          </div>
          <div class='o-layout__item u-1/1 u-1/2@tablet'></div>
        </div>
      </Form>
    </:body>
  </Window>
</template>
